import application from './application';
import userSpecification from './userSpecification';

export default { userSpecification, application };
